import { HttpError } from '../connectivity/http-error';

/**
 * Maps a refusal onto a text key, for every section of "Mein Profil". Only a refused command (HTTP 500
 * with the backend's code) gets a refusal text; a 403 is "not allowed"; anything else is general. The
 * 401 branch is defensive: today `BackendClient` turns a 401 into a plain Error and a global logout
 * before any HttpError reaches a page, but should one arrive (the login ended, e.g. after a password
 * change elsewhere), it must never show "wrong password", whatever code rides along.
 */
export function refusalKey<C extends Record<string, number>>(error: unknown, codes: C): keyof C | 'forbidden' | 'failed' {
    if (!(error instanceof HttpError) || error.status === 401) {
        return 'failed';
    }
    if (error.status === 403) {
        return 'forbidden';
    }
    const match = (Object.keys(codes) as (keyof C)[]).find(key => codes[key] === error.serverCode);

    return match ?? 'failed';
}
